import { render, staticRenderFns } from "./RiskLeaderList.vue?vue&type=template&id=4c0b4d0c&scoped=true"
import script from "./RiskLeaderList.vue?vue&type=script&lang=js"
export * from "./RiskLeaderList.vue?vue&type=script&lang=js"
import style0 from "./RiskLeaderList.vue?vue&type=style&index=0&id=4c0b4d0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b4d0c",
  null
  
)

export default component.exports